import { useApi } from '@backstage/core-plugin-api';
import { sev2ApiRef, SearchFileRequest, SearchFileResponse } from '@internal/backstage-plugin-sev2';
import { useCallback } from 'react';
import { useAsyncFn } from 'react-use';

export const useSearchFile = () => {
    const api = useApi(sev2ApiRef);

    const apiSearchFile = useCallback(
      async (params: SearchFileRequest) : Promise<SearchFileResponse> => {
        try {
          return await api.searchFile(params);
        } catch (err: any) {
          return err;
        }
      },
      [api],
    );

    const [state, searchFile] = useAsyncFn(
      (params: SearchFileRequest) => apiSearchFile(params),
      [],
    );

    return {
      loading: state.loading,
      data: state?.value,
      error: state.error,
      searchFile,
    };
};
